<template>
  <div class="dynamic-sensing">
    <div class="dynamic-sensing__panel">
      <div class="dynamic-sensing__panel__header">
        {{ $t('detail.dynamic_sensing') }}
        <button class="btn-set-dynamic" @click="updateTentacle()">
          {{ $t('detail.set_dynamic_sensing') }}
        </button>
      </div>
      <div class="dynamic-sensing__panel__content">
        <div class="detail-settings">
            <div class="settings-row">
              <div class="left">
                <div class="settings-row__name__title">{{ $t('detail.payload_format') }}</div>
                <div class="settings-row__name__description" v-if="device.payload.updated !== null">{{ $t('detail.payload_format_updated') }}: {{ this.compDatetime(device.payload.updated) }}</div>
              </div>
              <div class="right">
                <div class="lqi-info" v-if="device.payload.ackType">{{device.payload.payloadFormats[device.payload.ackType].name}}</div>
              </div>
            </div>
            <div class="settings-row">
              <div class="left">
                <div class="settings-row__name__title" for="">{{ $t('detail.measurement_frame') }}:</div>
                <div class="settings-row__name__description" v-if="device.payload.changed !== null">{{ $t('detail.payload_format_changed') }}: {{ changedAt }}</div>
              </div>
              <div class="right">
                <select v-model="device.payload.userType">
                  <option v-for="(payloadFormat, type) in device.payload.payloadFormats"
                          :value="type"
                          :key="payloadFormat.name"
                          :selected="selectedFormat">
                      {{ payloadFormat.name }}
                  </option>
                </select>
              </div>
            </div>
            <div :class="'settings-row' + (isAutomaticMode && this.user.is_expert ? ' warning' : '')" v-if="!isAutomaticMode || user.is_expert">
                <label for="userMessagesInInterval">{{ $t('detail.measurement_sets') }}:</label>
                <select name="userMessagesInInterval" v-model="device.payload.userMessagesInInterval" id="userMessagesInInterval">
                    <option v-for="value of accMeasurementsSets" v-bind:key="value" :value="value">{{ value }}</option>
                </select>
            </div>
            <div v-if="device.version.minuteSelection" class="settings-row">
                <div class="left">
                    <label for="downlinkPeriod">
                        {{ $t('detail.measurement_interval_span') }}:
                    </label>
                    <div class="settings-row__name__description">
                        {{ $t('detail.measurement_interval_span_hint') }}
                    </div>
                </div>
                <div class="right">
                    <select name="measurementIntervalSpan"
                            v-model="device.payload.userMeasurementIntervalSpan"
                            id="measurementIntervalSpan">
                        <option v-for="value of measurementIntervalsOptions" v-bind:key="value"
                                :value="value">{{ value }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="settings-row">
                <div class="left">
                    <label for="measurementInterval">
                        {{ $t('detail.measurement_interval') }}:</label>
                    <div class="settings-row__name__description">
                        {{ $t('detail.measurement_interval_hint') }}
                    </div>
                </div>
                <div class="right">
                    <select name="measurementInterval"
                            v-model="device.payload.userOmittedMessages"
                            id="measurementInterval">
                        <option v-for="(value, index) of measurementIntervals" v-bind:key="index"
                                :value="index">{{ value }}
                        </option>
                    </select>
                </div>
            </div>
            <div :class="'settings-row' + (isAutomaticMode && this.user.is_expert ? ' warning' : '')" v-if="!isAutomaticMode || user.is_expert">
                <label for="downlinkPeriod">{{ $t('detail.downlik_period') }}:</label>
                <select name="downlinkPeriod" v-model="device.payload.downlinkPeriod" id="downlinkPeriod">
                    <option v-for="period of downlinkPeriods" v-bind:key="period.value" :value="period.value">{{ period.label }}</option>
                </select>
            </div>
            <div :class="'settings-row' + (isAutomaticMode && this.user.is_expert ? ' warning' : '')" v-if="!isAutomaticMode || user.is_expert">
                <label for="downlinkRetries">{{ $t('detail.downlink_retries') }}:</label>
                <select name="downlinkRetries" v-model="device.payload.downlinkRetries" id="downlinkRetries">
                    <option v-for="(value, index) of downlinkRetriesArray" v-bind:key="value" :value="value">{{ index }}</option>
                </select>
            </div>
            <div :class="'settings-row' + (isAutomaticMode && this.user.is_expert ? ' warning' : '')" v-if="!disabledTransmittingPower && (!isAutomaticMode || this.user.is_expert)">
                <label for="transmittingPower">{{ $t('detail.transmitting_power') }}:</label>
                <select name="transmittingPower" v-model="device.payload.transmittingPower" id="transmittingPower">
                    <option v-for="(value, index) of transmittingPowerArray" v-bind:key="value" :value="value">{{ index }}</option>
                </select>
            </div>
            <div class="settings-row" v-if="this.user.is_expert">
                <!-- This is just for testing purposes and for certain users only. -->
                <label for="sigfoxFramesTransmitted">{{ $t('detail.sigfox_frames_transmitted') }}:</label>
                <select name="sigfoxFramesTransmitted" v-model="device.payload.sigfoxFramesTransmitted" id="sigfoxFramesTransmitted">
                    <option v-for="(value, index) of sigfoxFramesTransmittedArray" v-bind:key="value" :value="value">{{ index }}</option>
                </select>
            </div>
            <div class="settings-row" v-if="this.user.is_expert">
                <label for="loraConnection">{{ $t('detail.lora_connections') }}:</label>
                <select name="loraConnection" v-model="device.lora.id" id="loraConnection">
                    <option v-for="(value) of loraConnectionsArray" v-bind:key=value.id :value=value.id>{{ value.name }}</option>
                </select>
            </div>
            <div class="settings-row">
                <label for="message_interval">{{ $t('detail.message_interval') }}:</label>
                <input id="message_interval" name="message_interval" type="text" disabled :value="messageInterval">
            </div>
            <div class="settings-row">
                <label for="device_lifespan" v-if="!this.hasLora" >{{ $t('detail.sigfox_device_lifespan') }}:</label>
                <label for="device_lifespan" v-if="this.hasLora" >{{ $t('detail.device_lifespan') }}:</label>
                <div style="display: flex;">
                  <input v-if="!this.hasLora" id="device_lifespan" name="device_lifespan" type="text" disabled :value="deviceLifespan">
                  <input v-if="this.hasLora" id="device_lifespan" class="device-lifespan-left" name="device_lifespan" type="text" disabled :value="deviceLifespan + ' SigFox'">
                  <input v-if="this.hasLora" id="lora_device_lifespan" class="device-lifespan-right" name="lora_device_lifespan" type="text" disabled :value="loraDeviceLifespan + ' LoRa'">
                </div>
            </div>
            <div class="sa-info-row" v-if="isAutomaticMode && !this.user.is_expert">{{ $t('detail.sa_automatic_mode') }}</div>
            <div class="expert-info-row error" v-if="isAutomaticMode && this.user.is_expert">{{ $t('detail.expert_mode') }}</div>
            <div class="expert-info-row info" v-if="isScalingOn && this.user.is_expert">{{ $t('detail.data_auto_scaling') }} [O: {{ scalingOveralCoefficient }}, BMT: {{ scalingZoneCoefficient }}]</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BatchSelection from '@/views/detail/BatchSelection.vue';
import versionService from '@/services/VersionServices';
import {mapGetters} from "vuex";
// import store from '@/store';

export default {
  name: 'DetailSettingsRow',
  components: {
    BatchSelection,
    versionService
  },
  props: {
    device: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      downlinkRetriesArray: {'0':'0', '1':'1', '2':'2', '3':'3'},
      transmittingPowerArray: {'20%':'7','25%':'8','33%':'9','40%':'10','50%':'11','65%':'12', '80%':'13', '100% (default)':'14', '125%':'15'},
      sigfoxFramesTransmittedArray: { 'No Change': '0', '1 SigFox Frame': '1', '3 SigFox Frames': '2' },
      modal: false,
      changedAt: this.compDatetime(this.device.payload.changed),
    };
  },
  computed: {
    ...mapGetters('tentacle', ['user', 'is_expert']),
    hasLora() {
      return this.device.lora && this.device.lora.deviceEui;
    },
    isAutomaticMode: function () {
      return this.device.saSelected.id !== 0;
    },
    isScalingOn: function () {
      return typeof this.device.version !== 'undefined' && this.device.version.dataAutoScaling !== 0;
    },
    scalingOveralCoefficient: function () {
      const sensor = this.device.sensors.find(sensor => sensor.name === 'Moisture');
      return (sensor && sensor.calibrationScaleCoefficient) ? sensor.calibrationScaleCoefficient.toFixed(3) : 1;
    },
    scalingZoneCoefficient: function () {
      const sensor = this.device.sensors.find(sensor => sensor.name === 'Moisture Top');
      return (sensor && sensor.calibrationScaleCoefficient ) ? sensor.calibrationScaleCoefficient.toFixed(3) : 1;
    },
    loraConnectionsArray: function () {
      return this.device.lora.connections;
    },
    accMeasurementsSets: function () {
      let range = [];

      if (Object.prototype.hasOwnProperty.call(this.device.payload.payloadFormats, this.device.payload.userType)) {
        range = this.device.payload.payloadFormats[this.device.payload.userType].options;
      }

      if (!range.includes(parseInt(this.device.payload.userMessagesInInterval))) {
        this.device.payload.userMessagesInInterval = range[0];
      }

      return range;
    },
    downlinkPeriods: function () {
        let minutes = 15;
        if (typeof this.device.version !== 'undefined' && this.device.version.minuteSelection) {
            minutes = this.measurementIntervalMinutes;
        }

        const maxDownlinkRaw = 1440 / (254 * minutes);
        const maxDownlink = parseFloat(maxDownlinkRaw.toFixed(3));
        const downLinkValues = [maxDownlink, 0.25, 0.5, 1, 2];
        let minutesTillDownLink = 1440 / (((parseInt(this.device.payload.userOmittedMessages) + 1) * minutes * parseInt(this.device.payload.userMessagesInInterval)) * 255);
        let closest = 2;
        downLinkValues.forEach(value => {
            if (value >= minutesTillDownLink && value < closest) {
                closest = value;
            }
        });

      if (parseInt(this.device.payload.userType) === 6 && parseInt(this.device.payload.userMessagesInInterval) === 6) {
        this.device.payload.downlinkPeriod = 1;
        return [{label: this.$t('detail.once_per_day'), value: 1}];
      } else if (parseInt(this.device.payload.userType) === 6 && parseInt(this.device.payload.userMessagesInInterval) === 12) {
        this.device.payload.downlinkPeriod = 0.5;
        return [{label: this.$t('detail.once_per_two'), value: 0.5}];
      } else {
          let results = [];
          let options = [
              {
                  label: this.$t('detail.once_per_four'),
                  value: 0.25,
              },
              {
                  label: this.$t('detail.once_per_two'),
                  value: 0.5,
              },
              {
                  label: this.$t('detail.once_per_day'),
                  value: 1,
              },
              {
                  label: this.$t('detail.twice_per_day'),
                  value: 2,
              },
          ];

          const  isMaxAllowed = parseInt(this.device.payload.userMessagesInInterval) === 1 && parseInt(this.device.payload.userOmittedMessages) === 0;
          if (isMaxAllowed) {
              options.unshift({
                  label: this.$t('detail.downlink_max'),
                  value: -1,
              });
          }

          options.forEach(value => {
              const isMax = value.value === -1 && isMaxAllowed;
              if (value.value >= closest || isMax) {
                  results.push(value);
                  if(parseFloat(this.device.payload.downlinkPeriod) < closest) {
                      const closestToSet = closest === maxDownlink ? -1 : closest;
                      this.device.payload.downlinkPeriod = closestToSet;
                  }
              }
          });
        return results;
      }
    },
    measurementIntervalsOptions: function () {
        if (parseInt(this.device.payload.userType) === 6) {
            this.device.payload.userMeasurementIntervalSpan = 15;
            return [15];
        }

        if (typeof this.device.version !== 'undefined') {
            const options = this.device.version.minuteOptions;

            if (options.indexOf(this.device.payload.userMeasurementIntervalSpan) === -1) {
                this.$set(this.device.payload, 'userMeasurementIntervalSpan', 15);
            }

            if (typeof options !== 'undefined') {
                return options;
            } else {
                return [15];
            }
        }
    },
    measurementIntervalMinutes: function () {
        let span = 15;
        if (typeof this.device.payload.userMeasurementIntervalSpan !== 'undefined') {
            if ( this.device.payload.userMeasurementIntervalSpan <= 15 && this.device.payload.userMeasurementIntervalSpan >= 1) {
                span = this.device.payload.userMeasurementIntervalSpan;
            }
        }

        return span;
    },
    measurementIntervals: function () {
      if (parseInt(this.device.payload.userType) === 6) {
        this.device.payload.userMeasurementIntervalSpan = 15;
        this.device.payload.userOmittedMessages = 15;
        return {15: 240};
      }

      let minutes = 15;
      if (typeof this.device.version !== 'undefined' && this.device.version.minuteSelection) {
          minutes = this.measurementIntervalMinutes;
      }

      const range = {};
      for (let i = 0; i <= 15; i += 1) {
        range[i] = (i + 1) * minutes;
      }
      return range;
    },
    messageInterval: function () {
      let minutes = 15;
      if (typeof this.device.version !== 'undefined' && this.device.version.minuteSelection) {
        minutes = this.measurementIntervalMinutes;
      }
      return ((parseInt(this.device.payload.userOmittedMessages) + 1) * minutes) * parseInt(this.device.payload.userMessagesInInterval);
    },
    deviceLifespan: function () {
      const maxMeasurments = {
        1: 3,
        2: 5,
        3: 5,
        4: 10,
        5: 4,
        6: 12,
        7: 2,
        8: 3,
        9: 3,
        10: 3,
      };

      var messageRatio = parseInt(this.device.payload.userMessagesInInterval) / maxMeasurments[this.device.payload.userType];
      let messageConsumptionValue = 0.23424;
      if (messageRatio < 0.32) {
          messageConsumptionValue = 0.169824;
      } else if (messageRatio < 0.65) {
          messageConsumptionValue = 0.20496;
      }
      const version = this.device.version;

      const sigfoxFramesTransmitted = parseInt(this.device.payload.sigfoxFramesTransmitted);
      const messageIntervalValue = parseInt(this.messageInterval);
      const downlinkPeriodValue = parseFloat(this.device.payload.downlinkPeriod);
      const txPowerValue = this.device.payload.transmittingPower;
      const txCoefficientValue = 0.00137 * Math.pow(txPowerValue, 3) - 0.03852 * Math.pow(txPowerValue, 2) + 0.4025 * txPowerValue - 0.8054;

      let lifeSpan = NaN;

      if (version && version.batteryFormula){
        //assoc function used to allow variable mapping to custom coefficients
        const assoc = function (a, b) {
          return b[a];
        };
        lifeSpan = eval(version.batteryFormula);
      }

      if (isNaN(lifeSpan)) {
        return (5040 / ((1.380821918 + (1440 / parseInt(this.messageInterval)) * messageConsumptionValue + 0.20528 * parseFloat(this.device.payload.downlinkPeriod)) * 365)).toFixed(1);
      }

      return lifeSpan.toFixed(1);
    },
    loraDeviceLifespan: function () {
      const maxMeasurments = {
          1: 3,
          2: 5,
          3: 5,
          4: 10,
          5: 4,
          6: 12,
          7: 2,
          8: 3,
          9: 3,
          10: 3,
      };

      var messageRatio = parseInt(this.device.payload.userMessagesInInterval) / maxMeasurments[this.device.payload.userType];  // maxMeasurementsInFrame is variable defining maximum measurement sets in current frame. It changes when different frame is selected.
      let messageConsumptionValue = 0.23424;
      if (messageRatio < 0.32) {
          messageConsumptionValue = 0.169824;
      } else if (messageRatio < 0.65) {
          messageConsumptionValue = 0.20496;
      }
      const version = this.device.version;

      const dataRate = parseInt(this.device.payload.loraDataRate);
      const messageIntervalValue = parseInt(this.messageInterval);
      const downlinkPeriodValue = parseFloat(this.device.payload.downlinkPeriod);
      const txPowerValue = this.device.payload.transmittingPower;
      const txCoefficientValue = 0.00137 * Math.pow(txPowerValue, 3) - 0.03852 * Math.pow(txPowerValue, 2) + 0.4025 * txPowerValue - 0.8054;

      let loraLifespan = NaN;

      if (version && version.loraBatteryFormula){
        const assoc = function (a, b) {
          return b[a];
        };
        loraLifespan = eval(version.loraBatteryFormula);
      }

      if (isNaN(loraLifespan)) {
        return (5040 / ((1.380821918 + (1440 / parseInt(this.messageInterval)) * messageConsumptionValue + 0.20528 * parseFloat(this.device.payload.downlinkPeriod)) * 365)).toFixed(1);
      }

      return loraLifespan.toFixed(1);
    },
    selectedFormat() {
      return 1;
    },
    disabledTransmittingPower() {
      return versionService.disabledTransmittingPower(this.device.version);
    },
  },
  methods: {
    compDatetime(timestamp) {
      const newDate = new Date(Number(timestamp) * 1000);
      //let utcDate = this.getUtcDateTime(newDate);
      this.moment.locale(this.$i18n.locale.toLowerCase());
      return this.moment(newDate).format(this.timeFormat ? 'DD MMM YYYY hh:mm a' : 'DD MMM YYYY HH:mm');
    },
    getUtcDateTime(date){
      return new Date(date.getUTCFullYear(),date.getUTCMonth(),date.getUTCDate(),date.getUTCHours(),date.getUTCMinutes(),date.getUTCSeconds());
    },
    isUserDealer() {
      let user = this.$store.getters['tentacle/user'];
      return user ? user.is_dealer : false;
    },
    updateTentacle() {
      const data = [{
        id: this.device.id,
        userPayloadFormatType: this.device.payload.userType,
        userMessagesInInterval: this.device.payload.userMessagesInInterval,
        userMeasurementIntervalSpan: this.device.payload.userMeasurementIntervalSpan,
        userOmittedMessages: this.device.payload.userOmittedMessages,
        sigfoxFramesTransmitted: this.device.payload.sigfoxFramesTransmitted,
        loraActiveDevice: this.device.lora.id,
        downlinkPeriod: this.device.payload.downlinkPeriod,
        downlinkRetries: this.device.payload.downlinkRetries,
        transmittingPower: this.device.payload.transmittingPower,
      }];

      this.$store.dispatch('tentacle/updateUnit', data).then((response) => {
        if (response.status === 200) {
            this.flash('Tentacles updated', 'success');
            this.$store.dispatch('tentacle/setUnitByID', this.device.id).then((response) => {
                if (response.status === 200) {
                    this.changedAt = this.compDatetime(response.data.payload.changed);
                }
            });
        }
      });
    },
  },
  mounted () {
    //console.log(this.device)
  }
};
</script>

<style lang="scss" scoped>
.dynamic-sensing {
  margin-top: 4rem;
  padding-left: 8rem;
    @media only screen and (max-width: 990px) {
        padding-left: 0;
        width: 90%;
        margin-right: auto;
        margin-left: 5%;
    }
    @media only screen and (min-width: 991px) and (max-width: 1199px) {
        padding-left: 0;
        width: 90%;
        margin-right: auto;
        margin-left: 5%;
    }
    @media only screen and (min-width: 1200px) and (max-width: 1400px) {
        margin-left: -4%;
        width: 100%;
    }

  &__panel {
    border-radius: 2rem;
    background-color: #fff;
    box-shadow: 0 0 5px rgba(100, 116, 160, 0.1);
    position: relative;

    .loading-wrapper {
      position: absolute;
      top: 5rem;
      width: 100%;
      height: calc(100% - 10rem);
      background-color: rgba(255, 255, 255, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
    }

    &__header {
      padding: 0 3rem;
      height: 6rem;
      border-bottom: 0.1rem solid $border-color;
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 1.4rem;
      color: $grey;

      button {
        width: 150px;
        color: #f7f7f7;
        margin-left: auto;
        margin-top: 0.5rem;
        background-color: $company-color;
        border: none;
        border-radius: 4px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        height: 2.8rem;
        cursor: pointer;
        -webkit-transition: all 0.4s;
        transition: all 0.4s;
      }
    }

    &__content {
      padding: 2rem 3rem;
      font-size: 1.3rem;
      @media only screen and (max-width: 1400px) {
        min-height: 26rem;
      }
    }
  }

    .detail-settings {
        .settings-row {
            display: flex;
            justify-content: space-between;
            padding: 0;

            &.warning {
              color: $red-affected;
            }

            .lqi-info {
              margin-left: auto;
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              padding: 10px 15px;
              line-height: 20px;
              font-size: 15px;
              font-weight: 500;
            }

            select {
              max-width: 20rem;
            }

            &:last-of-type {
              border-bottom: 0;
            }

            input {
                border: 1px solid $border-color;
                color: $middle-grey;
                background-color: $bg;
                border-radius: 3px;
                line-height: 2rem;
                padding: 0.3rem 1rem;
                min-width: 10rem;
                max-width: 20rem;
            }

            input.device-lifespan-left {
              border-radius: 3px 0px 0px 3px;
              width: 9rem;
              float: right;
            }

            input.device-lifespan-right {
              border-radius: 0px 3px 3px 0px;
              width: 9rem;
              border-left: solid 1px gray;
            }
        }
    }

    .sa-info-row {
      padding-top: 1rem;
      color: $grey;
    }

    .expert-info-row {
      padding-top: 1rem;

      &.error{
        color: $red-affected;
      }

      &.info{
        color: green;
      }
    }
}

</style>
